import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

// add by Incograf® @ 2020/06
import { Configs } from "../../Toolbox";
let dfltLang = Configs.default_lang; //? Configs.default_lang : "en";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: Configs.default_lang, // dfltLang ? dfltLang : "en",
    backend: {
      /* translation file path */
      loadPath: "/assets/i18n/{{ns}}/{{lng}}.json",
    },
    fallbackLng: "pt",
    debug: true,
    /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
    react: {
      wait: true,
    },
    returnObjects: true,
  });

export default i18n;
